import { createStyles, makeStyles } from '@material-ui/styles';
import AutumnLeaf from '../../../../assets/seasons/ChallengeBanner/autumnleaf.webp';
import AutumnLeafB from '../../../../assets/seasons/ChallengeBanner/autumnleafb.webp';
import SpringLeaf from '../../../../assets/seasons/ChallengeBanner/springleaf.webp';
import SpringLeafB from '../../../../assets/seasons/ChallengeBanner/springleafb.webp';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      borderRadius: palette.borderRadius.extraLarge,
      transition: '0.3s ease',
      color: palette.text.white,
      fontWeight: 700,
      fontSize: '2rem',
      height: '164px',
      paddingLeft: '10px',
      paddingRight: '10px',
      boxShadow: palette.shadows.bannerShadow,
      textShadow: palette.shadows.textShadow,
      border: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundRepeat: 'repeat, repeat-y, repeat-y',
      '@media (max-width: 525px)': {
        textAlign: 'center'
      }
    },
    default: {
      backgroundColor: palette.background.dark
    },
    autumn: {
      backgroundImage: `url(${AutumnLeafB}), url(${AutumnLeaf}), url(${AutumnLeaf})`,
      backgroundSize: 'cover, 70%, 70%',
      backgroundColor: palette.background.autumn,
      animation: `$leafAnimation 60000ms linear infinite`
    },
    spring: {
      backgroundImage: `url(${SpringLeafB}), url(${SpringLeaf}), url(${SpringLeaf})`,
      backgroundSize: 'cover, 50%, 50%',
      backgroundColor: palette.background.spring,
      animation: `$leafAnimation 60000ms linear infinite`
    },
    '@keyframes leafAnimation': {
      '0%': {
        backgroundPosition: '0% 50%, 0% 0%, 100% 50%'
      },
      '99.8%': {
        backgroundPosition: '0% 1000%, 0% 300%, 100% 450%'
      },
      '100%': {
        backgroundPostition: '0% 50%, 0% 0%, 100% 50%'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
